import { getRegisterFunction } from '../../utils/register.js';
import { OneUxTabsElement } from './OneUxTabsElement.js';
export const register = getRegisterFunction(OneUxTabsElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-tabs': OneUxTabsElement;
    "tabs-056fa10a50eba3ee305583cdf6d74d3e": OneUxTabsElement;
  }
}